import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=dd3c911a&scoped=true&"
import script from "./addAddress.vue?vue&type=script&lang=js&"
export * from "./addAddress.vue?vue&type=script&lang=js&"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=dd3c911a&lang=less&scoped=true&"
import style1 from "./addAddress.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3c911a",
  null
  
)

component.options.__file = "addAddress.vue"
export default component.exports